import { region } from '@/utils/environment';

const routing = {
  checkout: (platform: string): string => `/pay/${region}/invoice/${platform}`,
  success: `/pay/${region}/invoice/success`,
  error: `/pay/${region}/invoice/error`,
  payByLinkPayment: (intetntId: string): string => `/pay/${region}/link/payment/${intetntId}`,
  payByLinkPaymentSuccess: `/pay/${region}/link/payment/success`,
  payByLinkPaymentError: `/pay/${region}/link/payment/error`,
};

export default routing;
